<template>
  <b-container fluid class="py-3 flex-grow-1 d-flex flex-column">
    <section class="grid-filters">
      <b-row align-h="between" class="mb-3">
        <b-col
            cols="12"
            sm="5"
            md="4"
            lg="3"
            xl="7"
            class="order-0 d-sm-block mb-3 mb-sm-0"
            :class="{'d-none': !showSearch}"
        >
          <div class="flex">
            <search-filter
                :showSearch="showSearch"
                v-model="query.search"
            >
            </search-filter>

            <b-col cols="12"
                   sm="12"
                   md="4"
                   lg="4"
                   class="filters-top mb-3 mb-md-0 justify-content-lg-start"
            >
              <multiselect
                  class="flex-fill hide-tags"
                  v-model="filters.parentAssetType.value"
                  :multiple="filters.parentAssetType.multiple"
                  :options="filters.parentAssetType.options"
                  :placeholder="filters.parentAssetType.placeholder"
                  :hide-selected="true"
                  :value="filters.parentAssetType.value"
                  selectLabel=""
                  :key="filters.parentAssetType.field"
                  @select="updateSubTypeOptions"
              >
                <template #caret="{ toggle }">
                  <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                </template>
              </multiselect>
            </b-col>

            <b-col cols="12"
                   sm="12"
                   md="4"
                   lg="4"
                   class="filters-top mb-3 mb-md-0 justify-content-lg-start"
            >
              <multiselect
                  class="flex-fill hide-tags"
                  v-model="filters.assetType.value"
                  :multiple="filters.assetType.multiple"
                  :options="filters.assetType.options"
                  :placeholder="filters.assetType.placeholder"
                  :hide-selected="true"
                  :value="filters.assetType.value"
                  selectLabel=""
                  :key="filters.assetType.field"
              >
                <template #caret="{ toggle }">
                  <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                </template>
              </multiselect>
            </b-col>
          </div>
          <div class="mt-4" v-if="property.propertyId">
            <h4 v-text="propertyTitle"></h4>
          </div>
        </b-col>
        <b-col cols="12" sm="7" md="8" lg="9" xl="8" v-if="false">
          <b-row no-gutters class="justify-content-end">
            <b-col col sm="auto" class="pr-1">
              <b-button
                  :disabled="statusFilter !== null"
                  variant="primary"
                  class="text-center w-100 text-nowrap py-1 px-2"
                  id="approveButton"
                  @click="toggle.approved.value = !toggle.approved.value"
              >
                <font-awesome-icon
                    :icon="['far', 'eye' + (!toggle.approved.value ? '-slash' : '')]"
                    class="mr-1"
                ></font-awesome-icon>
                {{ toggle.approved.value ? 'Hide' : 'Show' }} Approved
              </b-button>
            </b-col>
            <b-col col sm="auto" class="pl-1 d-none d-md-block">
              <b-button
                  variant="tertiary"
                  class="text-left w-100 text-nowrap py-1 px-2 filters-toggle"
                  @click="toggle.filters.value = !toggle.filters.value"
              >
                <font-awesome-icon
                    :icon="['fas', 'filter']"
                    class="mr-1"
                ></font-awesome-icon>
                {{ toggle.filters.value ? 'Hide' : 'Show' }} Filters
              </b-button>
            </b-col>
            <b-col col sm="auto" class="pl-1 d-none d-md-block">
              <portal-target v-show="!actionsMenuVisible" name="properties-subnav"/>
            </b-col>
            <b-col col sm="auto" class="pl-1 d-block d-md-none">
              <b-button
                  variant="tertiary"
                  class="text-center w-100 text-nowrap py-1 px-2"
                  v-b-modal.quickFiltersModal
              >
                <font-awesome-icon
                    :icon="['fas', 'filter']"
                    class="mr-1"
                ></font-awesome-icon>
                Quick Filters
              </b-button>
            </b-col>
          </b-row>
          <b-row no-gutters class="justify-content-end d-none d-md-block" v-if="toggle.filters.value">
            <b-col cols="12" class="pt-3 text-right filters-top">
            </b-col>
          </b-row>
          <b-modal
              id="quickFiltersModal"
              static
              :title="`Quick Filters`"
              body-class="d-flex flex-column"
              ok-title="Apply"
              @ok="applyModalFilters"
              @show="onModalFilterShow"
              cancel-variant="outline-secondary"
          >
            <b-form-group
                :label="filter.placeholder"
                v-for="(filter, key) in filters"
                :key="filter.field"
                label-size="sm"
            >
              <multiselect
                  :id="key"
                  class="small w-100"
                  v-model="filter.modalValue"
                  :multiple="filter.multiple"
                  :options="filter.options"
                  :placeholder="filter.placeholder | filterPlaceholder"
                  :hide-selected="filter.multiple"
                  allowEmpty
                  selectLabel=""
              >
                <template #caret="{ toggle }">
                  <caret-icon @mousedown.prevent.stop="toggle"></caret-icon>
                </template>
              </multiselect>
            </b-form-group>
          </b-modal>
        </b-col>
      </b-row>
      <portal to="actions-subnav" v-if="showActionsDropdown()"
      >
        <b-dropdown
            no-caret
            right
            variant="outline-primary"
            toggle-class="py-1 px-2"
        >
          <template slot="button-content">
            Actions
            <font-awesome-icon
                class="ml-1"
                :icon="['fal', 'chevron-down']"
                size="xs"
            ></font-awesome-icon>
          </template>
          <b-dropdown-item
              @click="onClickDownloadCsv"
              v-if="$can($perm.ASSETS_DOWNLOAD_TO_CSV, $perm.PERMISSION_TYPE_ASSETS)"
          >
            <font-awesome-icon
                :icon="['fal', 'download']"
                size="sm"
            ></font-awesome-icon>
            Download CSV
          </b-dropdown-item>
        </b-dropdown>
      </portal>
    </section>

    <b-row class="flex-grow-1 d-flex flex-column">
      <b-col class="flex-grow-1 d-flex flex-column">
        <b-row class="grid-count mb-3 justify-content-between align-items-baseline">
          <b-col cols="8" class="d-flex align-items-baseline text-dark">
                        <span>
                          {{ count }} Results
                          <span class="font-weight-bold"
                                v-if="selectedCount > 0"
                          >
                            | {{ selectedCount }} selected
                          </span>
                        </span>
          </b-col>
          <b-col cols="4" class="d-flex justify-content-end">
            <reset-filters
                @click="resetGridFilters"></reset-filters>
            <refresh-button
                :spinning="refreshing"
                @click="refresh"
            ></refresh-button>
          </b-col>
        </b-row>
        <div v-if="allFilters.length > 0" class="filters-all mb-2">
          <div class="filters-all-items">
            <b-badge :key="filter.label"
                     @click="removeFilter(filter)"
                     pill
                     v-for="filter in allFilters"
                     variant="secondary"
                     class="mb-2"
            >
              {{ filter.label }}
              <font-awesome-icon
                  :icon="['fal', 'times-circle']"
              ></font-awesome-icon>
            </b-badge>
            <span
                @click="resetFilters"
                class="filters-reset small"
            >Reset all</span>
          </div>
        </div>
        <div class="grid-wrapper flex-grow-1 d-flex">
          <ag-grid-vue
              class="ag-theme-balham"

              :cacheQuickFilter="cacheQuickFilter"

              :columnDefs="columnDefs"
              @columnMoved="saveGridOptions"
              @columnPinned="saveGridOptions"
              @columnResized="saveGridOptions"
              :columnTypes="columnTypes"
              @columnVisible="saveGridOptions"
              :defaultColDef="defaultColDef"

              :doesExternalFilterPass="doesExternalFilterPass"

              @filterChanged="saveGridOptions"
              :floatingFilter="floatingFilter"
              :gridOptions="gridOptions"
              @grid-ready="onGridReady"

              :headerHeight="rowHeight"
              :isExternalFilterPresent="isExternalFilterActive"
              :quickFilter="query.search"
              :rowData="rowData"

              :rowHeight="rowHeight"
              @rowSelected="updateRowSelected"

              :rowSelection="rowSelection"
              :side-bar="sideBarDef"

              @sortChanged="saveGridOptions"

              :style="'width: ' + gridWidth +'%; height: 100%;'"
              :suppressExcelExport="suppressExcelExport"
          ></ag-grid-vue>
        </div>
      </b-col>
    </b-row>
    <router-view name="clientActionPage"></router-view>
  </b-container>
</template>


<script lang="js">
import {AgGridVue} from 'ag-grid-vue';
import {filter as objFilter, forEach, size} from 'lodash';
import {mapGetters} from 'vuex';
import {
  propertyAssetsGridColumnTypes,
  propertyAssetsGridDefaultColDef,
  queryGridColumns,
  getPropertyAssetsGridColumns,
} from '@/services/Assets/PropertyAssetsGridConfig';
import CaretIcon from '@/components/Form/CaretIcon';
import Assets from '@/services/Assets/Assets';
import ClientActionFilter from '@/services/Action/ClientActionFilter';
import debounce from 'lodash/debounce';
import GridMixin from '@/components/Grid/GridMixin';
import api from '@/api';
import ResetFilters from '@/components/Grid/ResetFilters';
import RefreshButton from '@/components/Grid/RefreshButton';
import SearchFilter from '@/components/Grid/SearchFilter';
import Property from "@/services/Property/Property";
import riskhub from "@/services/Riskhub/Riskhub";

const FILTER_SET = 'SET';
const FILTER_TEXT = 'TEXT';

export default {
  name: 'Property-Assets',
  components: {
    Assets,
    AgGridVue,
    CaretIcon,
    ResetFilters,
    RefreshButton,
    SearchFilter,
  },
  mixins: [GridMixin],
  data() {
    return {
      // This is for the API cancel request
      modelId: 'propertyAssets',
      property: {},
      cancelSource: null,
      ignoreWatches: false,
      assignOptions: [],
      filters: {
        user: {
          type: FILTER_SET,
          placeholder: 'Filter User',
          field: 'reviewer',
          multiple: true,
          options: [],
          value: [],
          modalValue: [],
          fill: true,
        },
        parentAssetType: {
          placeholder: 'Filter Asset Type',
          field: 'parentAssetType',
          multiple: false,
          external: true,
          filterFunction: node => this.filterBothAssetTypes(node),
          options: [],
          value: [],
          modalValue: [],
        },
        assetType: {
          placeholder: 'Filter Asset Sub Type',
          field: 'assetType',
          multiple: false,
          external: true,
          filterFunction: node => this.filterBothAssetTypes(node),
          options: [],
          value: [],
          modalValue: [],
        },
      },
      toggle: {
        filters: {
          value: true,
        },
        live: {
          value: true,
          options: [
            {
              text: 'Live',
              value: true,
            },
            {
              text: 'Non-live',
              value: false,
            },
            {
              text: 'All',
              value: null,
            },
          ],
        },
      },
      defaultColDef: propertyAssetsGridDefaultColDef,
      columnTypes: propertyAssetsGridColumnTypes,
      columnDefs: null,
      typeCols: null,
      propertyAssetTypes: [],
      validNodes: [],
      invalidNodes: [],
      invalidStatus: '',
      modals: {},
    };
  },

  computed: {

    ...mapGetters({
      clientId: 'userClientId',
      showSearch: 'actionShowSearch',
      actionsMenuVisible: 'actionsMenuVisible',
    }),

    propertyId() {
      return this.$route.params.propertyId;
    },

    propertyTitle() {
      const {
        uprn,
        buildingName,
        streetNumber,
        street,
        town,
        postcode,
      } = this.property;

      return [
        `UPRN: ${uprn}`,
        buildingName,
        `${streetNumber || ''} ${street || ''}`.trim(),
        town,
        postcode,
      ].filter(Boolean).join(', ');
    },

    statusFilter() {
      return 'assets';
    },

    /**
     * This combines all the filters that are applied via external dropdowns
     * It is used mainly for visual purposes
     * * */
    allFilters() {
      const allFilters = [];

      Object.entries(this.filters)
          .forEach(([type, item]) => {
            // If it's not an array, we push just the string with no index
            if (!Array.isArray(item.value)) {
              allFilters.push({
                type,
                index: 0,
                label: item.value,
              });
              return;
            }

            Object.values(item.value)
                .forEach((label, index) => {
                  allFilters.push({
                    type,
                    index,
                    label,
                  });
                });
          });

      return allFilters;
    },
  },

  watch: {
    async statusFilter() {
      // Wait for any extra components to render first before refreshing
      this.resetFilters();
      // await this.getAssetTypes();
      await this.setGridColumns();
      this.refresh();
    },

    '$store.getters.propertyTenure': function (value) {
      this.refresh();
    },
    'filters.user.value': function () {
      this.onFilterChange(this.filters.user);
    },
    'filters.parentAssetType.value': function (newValue, oldValue) {
      if (!newValue.length) {
        this.resetSubTypeOptions();
      }
      this.gridApi.onFilterChanged();
    },
    'filters.assetType.value': function () {
      this.gridApi.onFilterChanged();
    },
    'toggle.filters.value': function toggleShowFiltersValue() {
      this.gridApi.onFilterChanged();
    },
  },

  filters: {
    filterPlaceholder(placeholder) {
      return `Select ${placeholder.replace(/Filter/, '')}`;
    },
  },

  created() {
    this.fetch(this.propertyId);
    this.getAssetTypeOptions()

    this.columnDefs = getPropertyAssetsGridColumns().filter(this.filterColumn);
  },

  mounted() {
    this.onMountQueryParams();
  },

  methods: {
    async fetch(propertyId) {
      this.loading = true;
      this.property = {};

      try {
        const response = await Property.find(propertyId);
        this.property = response.data.data;
      } catch (e) {
        this.$router.push({ name: 'assetsProperties' }, () => {
          this.$notify({
            title: 'Property not found',
            text: 'Property could not be found.',
            type: 'error',
          });
        });
      } finally {
        this.loading = false;
      }
    },

    async getAssetTypeOptions() {
      let types = await this.getAssetTypes()
          .then((response) => {
            return response.data.data;
          })

      this.propertyAssetTypes = types
      this.filters.parentAssetType.options = types.filter(type => type.isParent).map(type => type.name)
      this.filters.assetType.options = types.filter(type => ! type.isParent).map(type => type.name)
    },

    getAssetTypes() {
      return api.get('/clients/asset-types');
    },

    postGridReady(params) {
      this.refresh();
    },

    /**
     * Resets grid to absolute default
     */
    preResetGridFilters() {
      this.resetting = true;
      forEach(this.filters, (filter, type) => {
        this.filters[type].value = [];
      });

      if (Object.entries(this.$router.currentRoute.query).length) {
        this.$router.replace({query: null}).catch(err => {
        });
      }
    },

    postResetGridFilters() {
      this.$nextTick(() => {
        this.resetting = false;
      });
    },

    /**
     * Set the grid columns based on permissions / status
     **/
    setGridColumns() {
      return new Promise((resolve) => {
        this.columnDefs = getPropertyAssetsGridColumns().filter(this.filterColumn);

        this.$nextTick(() => {
          resolve();
        });
      });
    },

    /**
     * Filter columns based on permissions
     *
     * @param {Object} column
     */
    filterColumn(column) {
      return !(column.field === 'dueDate' && !this.$can(
          this.$perm.ACTIONS_VIEW_ACTION_DUE_DATE,
          this.$perm.PERMISSION_TYPE_ACTION,
      ));
    },

    /**
     * Sets the grid up with:
     * Column state
     * Sort
     * Filters
     */
    setGridOptions() {
      let name = 'property-assets';
      let gridState = this.$store.getters.gridState(name);
      let gridSort = this.$store.getters.gridSort(name);
      let gridFilter = this.$store.getters.gridFilter(name);

      if (!gridState) {
        gridState = this.gridDefaults.state;
      }

      if (!gridSort) {
        gridSort = this.gridDefaults.sort;
      }

      if (!gridFilter) {
        gridFilter = this.gridDefaults.filter;
      }

      this.columnApi.setColumnState(gridState);

      if (this.hasQueryString()) {
        return;
      }

      this.gridApi.setSortModel(gridSort);
      this.gridApi.setFilterModel(gridFilter);
      this.gridApi.onFilterChanged();
      this.setTopFilterValues(gridFilter);
    },

    // Sets the filters at the top, which displays a visual representation
    // If grid options are saved, they can be reloaded in and set so the top level filters match too
    // Since all they do is trigger AG Grid's filters anyway
    setTopFilterValues(gridFilters) {
      forEach(gridFilters, (options, filterName) => {
        const matchFilter = objFilter(this.filters, f => f.field === filterName);

        if (matchFilter[0]) {
          matchFilter[0].value = options.values;
        }
      });
    },

    /**
     * Only allow to save the grid if it is not refreshing data
     * */
    saveGridOptions() {
      if (this.refreshing) {
        return false;
      }

      if (this.hasQueryString()) {
        return false;
      }

      return this.saveOptions();
    },

    /**
     * Save the grid options (only allowed once per second)
     */
    saveOptions: debounce(function () {
      const state = this.columnApi.getColumnState();
      const sort = this.gridApi.getSortModel();
      const filter = this.gridApi.getFilterModel();

      let name = 'property-' + this.statusFilter;

      if (!this.statusFilter) {
        name = 'property-assets';
      }

      this.$store.dispatch('saveGridOptions', {
        name,
        state,
        sort,
        filter,
      });
    }, 1000),

    /**
     * Checks if an external filter is actually active
     */
    isExternalFilterActive() {
      let active = false;
      Object.entries(this.filters)
          .forEach(([type, item]) => {
            if (!item.external) {
              return;
            }

            if (item.value && item.value.length > 0) {
              active = true;
            }
          });

      return active;
    },

    /**
     * Checks to see if all external filters pass (like being overdue)
     */
    doesExternalFilterPass(node) {
      let success = false;
      const filterPass = [];
      Object.entries(this.filters)
          .forEach(([type, item]) => {
            if (!item.external) {
              return;
            }

            if (item.filterFunction) {
              filterPass.push(item.filterFunction(node));
            }
          });

      filterPass.forEach((boolean) => {
        success = boolean;
      });

      // In case it is undefined
      if (!success) {
        success = false;
      }

      return success;
    },

    /**
     * Checks each row of data if they are a match
     */
    filterBothAssetTypes(node) {
      const selectedParentType = this.filters.parentAssetType.value;
      const selectedChildType = this.filters.assetType.value;

      if (selectedParentType.length > 0 && selectedChildType.length > 0) {
        return this.filterParentAssetType(node) && this.filterAssetType(node);
      }

      if (selectedParentType.length > 0) {
        return this.filterParentAssetType(node);
      }

      if (selectedChildType.length > 0) {
        return this.filterAssetType(node);
      }

      return false;
    },

    /**
     * Checks each row of data if they are a match
     */
    filterParentAssetType(node) {
      const selectedType = this.filters.parentAssetType.value;

      const parentMatch = !node.data.type.parent && selectedType === node.data.type.propertyAssetType;
      const childMatch = node.data.type.parent && selectedType === node.data.type.parent.propertyAssetType;

      return parentMatch || childMatch;
    },

    /**
     * Checks each row of data if they are a match
     */
    filterAssetType(node) {
      const selectedType = this.filters.assetType.value;

      return selectedType === node.data.type.propertyAssetType;
    },

    preRefresh() {
      return !!this.gridApi;
    },

    /**
     * Async
     * Refreshes the table
     * Sets the grid options afterwards
     */
    async refresh() {
      if (!this.preRefresh()) {
        return;
      }

      // Cancel any previous requests
      if (this.cancelSource) {
        this.cancelSource.cancel();
      }

      // Wait until the data is set, external dropdown filters are set
      await this.refreshData();
      // Then we set the grid options
      this.setGridOptions();
      // We set a timeout to disallow any future grid saving that happens
      // As filters are applied immediately after;
      this.postRefresh();
    },

    /**
     * Call after every refresh
     * */
    postRefresh() {
      this.postRefreshQueryParams();
      this.setDropdownFilters();
      this.updateRowSelected();
      this.gridApi.hideOverlay();

      setTimeout(() => {
        this.refreshing = false;
      }, 0);
    },

    /**
     * Sets the rowdata with data from the server
     */
    /**
     * Sets the rowdata with data from the server
     */
    refreshData() {
      this.refreshing = true;

      const params = this.getParams();

      this.cancelSource = api.CancelToken.source();

      let rowData = [];
      return Assets.propertyAssets(this.propertyId, params, this.cancelSource)
          .then((response) => {
            rowData = response.data.data;
          })
          .catch((error) => {
            if (!api.isCancel(error)) {
              this.$notify({
                duration: 5000,
                title: 'Error',
                text: 'We couldn\'t obtain the property assets right now. Please try again later.',
                type: 'error',
              });
            }
          })
          .finally(() => {
            this.rowData = rowData;
            this.refreshing = false;
          });
    },

    /**
     * Check if the current route has a query string present
     */
    hasQueryString() {
      const {query} = this.$route;

      return (query && size(query) > 0);
    },

    /**
     * Anything to do with query params that should happen on mount
     */
    onMountQueryParams() {
      if (!this.hasQueryString()) {
        return;
      }

      const {query} = this.$route;

      forEach(query, (value, field) => {
        if (Array.isArray(value)) {
          value = value[0];
        }
      });
    },

    /**
     * Apply any parameters from the query string to the grid
     */
    postRefreshQueryParams() {
      const {query} = this.$route;

      if (this.hasQueryString()) {
        forEach(query, (value, field) => {
          if (field === 'overdue') {
            const filters = {
              1: ClientActionFilter.FILTER_DATE_OVERDUE(),
              2: ClientActionFilter.FILTER_DATE_WITHIN(),
            };

            this.filters.overdue.value = filters[value];

            return;
          }

          this.onFilterChange({
            field,
            value,
            type: FILTER_SET,
          });
        });
      }
    },

    /**
     * Gets any params for fetching data from the server
     */
    getParams() {
      const params = {};

      params.sort = 'updatedDate';
      params.sortDir = 'DESC';

      return {
        params,
      };
    },

    /**
     * Set all filters for external dropdowns
     */
    setDropdownFilters() {
      // Duplicate filter object
      const filters = Object.entries(this.filters)
          .filter(([type, item]) =>
              !item.external
              && item.type === FILTER_SET
              && item.fill
          );
      // Add a set
      filters.forEach(([type, item]) => {
        item.set = new Set();
      });

      // Loop through each row of data
      // Add field to a unique set
      this.rowData.forEach((node) => {
        filters.forEach(([type, item]) => {
          const field = node[item.field];
          if (field !== undefined && field !== null) {
            item.set.add(field);
          }
        });
      });

      // Assign the set to the original filters as options
      filters.forEach(([type, item]) => {
        this.filters[type].options = [...item.set].sort();
      });
    },

    /**
     *  Reset all filters
     */
    resetFilters() {
      this.resetting = true;

      Object.entries(this.filters)
          .forEach(([type, item]) => {
            this.filters[type].value = [];
          });

      this.$nextTick(() => {
        this.resetting = false;
      });

      this.gridApi.setQuickFilter(null);
      this.query.search = '';
      this.gridApi.setFilterModel(this.gridDefaults.filter);
    },

    /**
     * Remove filter by type + index
     * @param type
     * @param index
     */
    removeFilter({type, index}) {
      if (!Array.isArray(this.filters[type].value)) {
        this.filters[type].value = [];
      } else {
        this.filters[type].value.splice(index, 1);
      }

      if (this.filters[type].type === FILTER_SET) {
        this.filterSet(this.filters[type]);
      } else if (this.filters[type].type === FILTER_TEXT) {
        this.filterText(this.filters[type]);
      }

      this.gridApi.onFilterChanged();
    },

    applyModalFilters() {
      Object.entries(this.filters)
          .forEach(([type, item]) => {
            this.filters[type].value = this.filters[type].modalValue;
          });

      this.applyFilters();
    },

    applyFilters() {
      Object.entries(this.filters)
          .forEach(([type, item]) => {
            if (item.type === FILTER_SET) {
              this.filterSet(item);
            } else if (item.type === FILTER_TEXT) {
              this.filterText(item);
            }
          });

      this.gridApi.onFilterChanged();
    },

    onModalFilterShow() {
      Object.entries(this.filters)
          .forEach(([type, item]) => {
            this.filters[type].modalValue = this.filters[type].value;
          });
    },

    onClickDownloadCsv() {
      const processCellCallback = (params) => {
        const column = params.column.getColId();
        let {value} = params;

        switch (column) {
          case 'query':
            value = value.replace(/<br \/>/g, '');
            value = value.replace(/\n/g, '');
            value = value.replace(/\r/g, ' ');
            break;

          case 'numberRange':
          case 'streetNumber':
            if (value) {
              value = `="${value}"`;
            }
            break;

          case 'dueDate':
          case 'createdDate':
          case 'updatedDate':
            value = riskhub.formatDate(value, true) || 'N/A';
            break;
        }

        return value;
      };

      const onlySelected = this.getSelectedNodes().length > 0;
      const params = {
        processCellCallback,
        onlySelected,
        columnKeys: [
            'propertyAssetId',
            'tagRef',
            'flatRef',
            'type',
            'type.propertyAssetType',
            'floorNumber',
            'flatNumber',
            'locationInformation',
            'createdDate',
            'updatedDate',
        ]
      };

      this.gridApi.exportDataAsCsv(params);
    },

    showActionsDropdown() {
      return this.$can(this.$perm.ASSETS_DOWNLOAD_TO_CSV, this.$perm.PERMISSION_TYPE_ASSETS);
    },

    updateSubTypeOptions(selectedType) {
      this.filters.assetType.options = this
          .propertyAssetTypes
          .filter(function (type) {
            if (type.name === selectedType) return true;

            if (type.parent && type.parent.propertyAssetType === selectedType) return true;

            return false;
          })
          .map(type => type.name)
    },

    resetSubTypeOptions() {
      this.filters.assetType.options = this
          .propertyAssetTypes
          .filter(type => ! type.isParent)
          .map(type => type.name)
    }
  },
};
</script>

<style lang="scss" scoped>
.filters-toggle {
  min-width: 130px;
}

.filters-top {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;

  > div {
    margin-left: 15px;
  }

  .multiselect {
    max-width: 260px;
    min-width: 150px;
    min-height: 36px;

    /deep/ &__input {
      font-size: 15px;
      border-color: $border-color;
    }

    /deep/ &__placeholder {
      display: none;
    }

    /deep/ &__caret {
      top: 5.5px !important;
    }
  }

  /deep/ .multiselect__tags {
    border-color: $border-color;
    padding-top: 0.2rem !important;
    padding-bottom: 0.2rem !important;
    padding-left: 0.2rem !important;
    min-height: 14px;
  }
}

.filters-all {
  .filters-reset {
    color: #848484;
    cursor: pointer;
    text-decoration: underline;
  }

  .badge {
    margin-right: 0.75rem;
    font-size: 14px;
    padding: 5px 10px;
    font-weight: $font-weight-base;
    cursor: pointer;

    .fa-times-circle {
      margin-left: 5px;
    }
  }
}

@media screen and (max-width: 992px) {
  .filters-top {
    > div {
      margin-left: 5px;
    }

    .multiselect {
      /deep/ &__input {
        font-size: 12px;
      }
    }

    /deep/ .multiselect__tags {
      padding-left: 0.2rem !important;
    }

    .ag-wide {
      min-width: 300px;
    }
  }
}
</style>
